import { Link } from "react-router-dom";

export default function BookingLink({ page = "unknown", action = "book_consultation", className = "", children, dataTestId = "booking-link", ...rest }) {
  const onClick = () => {
    try {
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action, page }),
        keepalive: true,
      }).catch(() => {});
    } catch (e) {
      /* lead tracking must never block the click */
    }
  };
  return (
    <Link to="/book-online" state={{ from: page }} onClick={onClick} data-testid={dataTestId} className={className} {...rest}>
      {children}
    </Link>
  );
}
